import React from "react";
import { Modal, Form } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useDeleteCampaignMutation } from "../../../../../redux/apiSlice";

export const DeleteCampaignModal = ({ showDeleteCampaignModal, onHide, details }) => {
  const [deleteCampaign] = useDeleteCampaignMutation();

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    deleteCampaign({ id: details?.campaignId })
      .unwrap()
      .then(() => {
        cogoToast.success("Campaign delete action successfull");
        onHide();
      })
  };

  return (
    <Modal
      show={showDeleteCampaignModal}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form noValidate onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Delete Campaign
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
          <p>Are you sure you want to delete this campaign?</p>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate px-4"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary btn-elevate px-4 ml-4"
          >
            Delete
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DeleteCampaignModal;
